import React from 'react';
import { graphql } from 'gatsby';
import { Helmet } from 'react-helmet';
import Layout from '../../components/Layout';
import MainCatalogPage from './MainCatalogPage';

export default (props) => {
  const { menu } = props.pageContext;
  const { storeName } = props.data.store.siteMetadata.gatsbyStorefrontConfig;
  return (
    <Layout>
      <MainCatalogPage {...props} />
    </Layout>
  );
};

export const vendorCatalogQuery = graphql`
  query VendorCatalogQuery($vendorName: String!, $categories: [String]!, $enableWebp: Boolean!) {
    vendor: allShopifyProduct (filter: { vendor: { eq: $vendorName }, productType: { in: $categories } }, sort: {fields: createdAt, order: DESC}) {
      nodes {
        title
        handle
        id
        shopifyId
        tags,
        productType,
        fields {
          shopifyThemePath
          firstImage {
            altText
            localFile {
              childImageSharp @include(if: $enableWebp) {
                fluid(
                  maxWidth: 450
                  maxHeight: 675
                  cropFocus: CENTER
                  fit: COVER
                  background: "white"
                  srcSetBreakpoints: [450]
                ) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
              childImageSharp @skip(if: $enableWebp) {
                fluid(
                  maxWidth: 450
                  maxHeight: 675
                  cropFocus: CENTER
                  fit: COVER
                  background: "white"
                  srcSetBreakpoints: [450]
                ) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
        availableForSale
        priceRange {
          minVariantPrice {
            amount
            currencyCode
          }
          maxVariantPrice {
            amount
            currencyCode
          }
        }
        variants {
          shopifyId
          availableForSale
          compareAtPrice
          price
        }
      }
    }
    store: site {
      siteMetadata {
        gatsbyStorefrontConfig {
          storeName
          gatsbyImageProps {
            loading
            fadeIn
            durationFadeIn
          }
        }
      }
    }
  }
`;